import { Grid, Typography } from '@material-ui/core';
import GridItem from 'components/Grid/GridItem.jsx';
import React from 'react';

const grandSeperator = val => {
	if(!val) {
		return "0"
	}
	
	val = val
		.toString()
		.replace(/,/g, '')
		.replace(/ /g, '');
	let parsed = parseInt(val);

	if (!isNaN(parsed)) {
		return parsed.toLocaleString().replace(/,/g, ' ');
	} else {
		return val;
	}
};

const customRow = (firstCol, secondCol, thirdCol) => {
	return (
	  <React.Fragment>
		<Grid item xs={12} sm={12} md={12}>
		  <Grid container>
			<GridItem xs={3} sm={3} md={3}>
			  {firstCol}
			</GridItem>
			<GridItem xs={2} sm={2} md={2}>
			  {secondCol}
			</GridItem>
			<GridItem xs={2} sm={2} md={2}>
			  {thirdCol}
			</GridItem>
			<GridItem xs={5} sm={5} md={5}>
			  
			</GridItem>
		  </Grid>
		</Grid>
	  </React.Fragment>
	);
  };

const Liquidity = props => {
	const liquidity = props.state.result.liquidity;

	return (
		<React.Fragment>
			{/* ============================== Cash needed to wind up estate =================================*/}
			{/* =============================================================================*/}

			<Grid
				direction="column"
				style={{ marginTop: '20px', marginBottom: '20px' }}
			>
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						<strong>Cash needed to wind up estate: </strong>
					</Typography>,
					null,
					<Typography style={{ paddingTop: '5px' }}>
						<strong>
							R {grandSeperator(parseFloat(liquidity.cashNeeded.netCashNeeded).toFixed(2))}
						</strong>
					</Typography>
				)}

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						CGT
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(liquidity.cashNeeded.netCgt)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Liabilities
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(liquidity.cashNeeded.netLiabilities)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Executors Fees
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(liquidity.cashNeeded.netExectutorsFee)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Estate Duty
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(liquidity.cashNeeded.netEstateDuty)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Other Costs
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(liquidity.cashNeeded.netOtherCosts)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Liquid Assets bequethed
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R{' '}
						{grandSeperator(
							liquidity.cashNeeded.netBequethedLiquidAssets
						)}
					</Typography>,
					null
				)}

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Cash bequests
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(liquidity.cashNeeded.netCashBequests)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Accrual claim
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(liquidity.cashNeeded.netAccrualClaim)}
					</Typography>,
					null
				)}

				<div style={{ marginTop: '20px' }} />
				{/* ================= Cash available =========================*/}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						<strong>Cash available:</strong>
					</Typography>,
					null,
					<Typography style={{ paddingTop: '5px' }}>
						<strong>R {grandSeperator(liquidity.cashAvailable.netCashAvailable)}</strong>
					</Typography>
				)}

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Cash
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(liquidity.cashAvailable.cash)}
					</Typography>,
					null
				)}

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Liquid Investments
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(liquidity.cashAvailable.netLiquidInvestments)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Assets converted to cash
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(liquidity.cashAvailable.netCashAssets)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Policies
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(liquidity.cashAvailable.netPolicies)}
					</Typography>,
					null
				)}
				

				<div style={{ marginTop: '20px' }} />
				{/* ================= Cash surplus/deficit =========================*/}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						<strong>Cash surplus/deficit:</strong>
					</Typography>,
					null,
					<Typography style={{ paddingTop: '5px' }}>
						<strong> R {grandSeperator(parseFloat(liquidity.cash).toFixed(2))}</strong>
					</Typography>
				)}
			</Grid>
		</React.Fragment>
	);
};

export default Liquidity;



// WEBPACK FOOTER //
// ./src/views/Fna/ResultsPage/results/Liquidity.jsx